// stores/useInstallPromptStore.js
import { defineStore } from 'pinia'

export const useInstallPromptStore = defineStore('installPrompt', {
  state: () => ({
    deferredPrompt: null,
    canInstall: false
  }),
  actions: {
    setDeferredPrompt(promptEvent) {
      this.deferredPrompt = promptEvent
      this.canInstall = true
    },
    clearDeferredPrompt() {
      this.deferredPrompt = null
      this.canInstall = false
    }
  }
})
